import axios from 'axios'

export const getIp = () => {
    const ip = axios.get('https://jsonip.com').then(response=>response.data.ip)
    return ip;
}